import { Link, withRouter } from "react-router-dom";
import tourSteps from "./steps.js";
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { toggleTourOff, closeTourButtonClicked, openEndTourModal } from '../../../redux/actions/toggleTourActions';
import { connect } from 'react-redux';
import React, { PureComponent } from "react";
  
  const TooltipBody = styled.div`
    background-color: #2d9aa6;
    color: #FFFFFF;
    border-radius: 20px;
    height: 190px;
    width: 400px;
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 20px;
  `;
  
  const TooltipTitle = styled.div`
    font-size: 16px;
    font-weight: 900;
  `;
  
  const TooltipContent = styled.div`
    font-size: 14px;
    font-weight: 100;
    padding-top: 10px;
  `;
  
  const SkipTour = styled.div`
    font-size: 14px;
    font-weight: 100;
    color: #abdbe3;
    text-decoration: underline;
    cursor: pointer;
  `;
  
  const StyledButton = withStyles({
    root: {
      background: '#FFFFFF',
      '&:hover': {
        background: '#FFFFFF'
      },
      borderRadius: 3,
      border: 0,
      color: '#2d9aa6',
      height: 24,
      boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    },
    label: {
      textTransform: 'none',
    },
  })(Button);
  
  const TooltipFooter = styled.div`
    padding-top: 18px;
    display: flex;
    justify-content: space-between;
  `;

class Tooltip extends PureComponent{
  
    skipTour = () => {
      this.props.dispatch(toggleTourOff());
      this.props.history.replace('/app/getting-started');
    };

    endTour = () => {
      this.props.dispatch(openEndTourModal());
      this.props.dispatch(closeTourButtonClicked());
    }
  
    render() {
      const {
        step = tourSteps,
        skipProps,
        primaryProps,
        tooltipProps,    
      } = this.props;
      return(
        <TooltipBody {...tooltipProps}>
        <TooltipTitle>{step.title}</TooltipTitle>
        <TooltipContent>{step.content}</TooltipContent>
        <TooltipFooter>
          <SkipTour
            {...skipProps}
            onClick={()=>{this.skipTour()}}
          >
            <Link
              style={{color: '#abdbe3'}} 
              to=''
            >
              Skip Tour
            </Link>
          </SkipTour>
    
          <StyledButton
            {...primaryProps}
            onClick={() => {
              this.endTour();
            }}
          >
            Complete Tour
          </StyledButton>
        </TooltipFooter>
      </TooltipBody>)
    }
  }

  function mapStateToProps(state) {
    return {
        user: state.auth.user,
        settings: state.auth.settings,
        toggleTour: state.toggleTour
    }
  }
  
  export default connect((mapStateToProps))(withRouter(Tooltip))


// WEBPACK FOOTER //
// ./src/components/tour/training/Tooltip.js